import React, { forwardRef } from 'react';

const Unarchived = forwardRef( ( props, ref ) => (
	<svg
		ref={ ref }
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 32 32"
		{ ...props }
	>
		<path d="M29 2.9H3c-.6 0-1 .4-1 1v5.7c0 .6.4 1 1 1h.9V28c0 .6.4 1 1 1h22.2c.6 0 1-.4 1-1V10.6h.9c.6 0 1-.4 1-1V3.9c0-.5-.4-1-1-1zm-2.9 24.2H5.9V10.6h20.2zM28 8.6H4V4.9h24z" />
		<path d="M12 17h8c.6 0 1-.4 1-1s-.4-1-1-1h-8c-.6 0-1 .4-1 1s.4 1 1 1z" />
	</svg>
) );

Unarchived.displayName = 'Unarchived';

export default Unarchived;
